import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "value", "disabled", "onChange", "tag", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { useFieldset } from '@segment/matcha/components/Fieldset/FieldsetContext';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './Checkbox.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseCheckbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      value = _ref.value,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      tag = _ref.tag,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var fieldsetContext = useFieldset();
  var isDisabled = disabled || (fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.disabledFieldset);
  return _jsx(views.Checkbox, _objectSpread(_objectSpread({
    name: name,
    type: "checkbox",
    value: value,
    disabled: Boolean(isDisabled),
    onChange: onChange,
    ref: ref,
    as: tag
  }, rest), tokens));
});
export var Checkbox = withDesignTokens(BaseCheckbox, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[400],
      hoverBorderColor: theme.palette.brand.darkAcai[500],
      checkedBackgroundColor: theme.palette.brand.segmentGreen[500],
      checkedBorderColor: theme.palette.brand.segmentGreen[500]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[500],
      hoverBorderColor: theme.palette.brand.darkAcai[400],
      checkedBackgroundColor: theme.palette.brand.segmentGreen[500],
      checkedBorderColor: theme.palette.brand.segmentGreen[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[40],
      hoverBorderColor: theme.palette.twilio.gray[60],
      checkedBackgroundColor: theme.palette.twilio.blue[60],
      checkedBorderColor: theme.palette.twilio.blue[60]
    };
  }
});